var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(-1518.955 -22.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(1518.955 22.955)",
    fill: "none",
    stroke: "#2c67a7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M3.053-6.147H4.939v-.4c0-.793.3-1.222,1.36-1.837a3.063,3.063,0,0,0,1.716-2.752v-.008c0-1.789-1.489-3.06-3.7-3.06-2.4,0-3.691,1.392-3.78,3.205l-.008.089h1.9l.008-.073a1.649,1.649,0,0,1,1.773-1.57,1.529,1.529,0,0,1,1.7,1.481v.008c0,.793-.34,1.23-1.344,1.837A2.534,2.534,0,0,0,3.053-6.714Zm.971,3.8A1.147,1.147,0,0,0,5.2-3.485,1.142,1.142,0,0,0,4.024-4.626,1.149,1.149,0,0,0,2.842-3.485,1.154,1.154,0,0,0,4.024-2.343Z",
    transform: "translate(1525.33 42.347)",
    fill: "#2c67a7",
    stroke: "#dcf0ff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpBlue);
export default __webpack_public_path__ + "static/media/help-blue.9fc614da8183c94013fc2c4045f2a647.svg";
export { ForwardRef as ReactComponent };